import React from 'react';

import { Box, Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useStyles } from './ExerciseItemSkeleton.styles';

const ExerciseItemSkeleton = () => {
  const theme = useTheme();

  const { classes } = useStyles(theme);

  return (
    <div className={classes.wrapper}>
      <Box className={classes.infoWrapper}>
        <Box className={classes.contentRow}>
          <Skeleton
            variant="circular"
            className={classes.avatarSkeleton}
            width={40}
            height={40}
          />
          <Box className={classes.leftBlock}>
            <Skeleton
              variant="text"
              className={classes.titleSkeleton}
              height={22}
              width="70%"
            />
          </Box>
          <Box className={classes.iconsBlock}>
            <Skeleton
              variant="circular"
              className={classes.iconSkeleton}
              width={24}
              height={24}
            />
            <Skeleton
              variant="circular"
              className={classes.iconSkeleton}
              width={24}
              height={24}
            />
            <Skeleton
              variant="circular"
              className={classes.iconSkeleton}
              width={24}
              height={24}
            />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default ExerciseItemSkeleton;
